import { Lock, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';

interface UpgradePromptProps {
    moduleName: string;
}

export function UpgradePrompt({ moduleName }: UpgradePromptProps) {
    const navigate = useNavigate();

    return (
        <div className="flex items-center justify-center min-h-[400px] p-8">
            <Card className="max-w-md text-center">
                <CardContent className="pt-6">
                    <div className="rounded-full bg-muted p-3 inline-block mb-4">
                        <Lock className="h-8 w-8 text-muted-foreground" />
                    </div>
                    <h2 className="text-xl font-semibold mb-2">{moduleName}</h2>
                    <p className="text-muted-foreground mb-6">
                        This module is not currently enabled for your workspace.
                        Visit your billing settings to update your selected modules or plan.
                    </p>
                    <Button onClick={() => navigate('/settings/billing')}>
                        Manage Modules
                        <ArrowRight className="h-4 w-4 ml-2" />
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
}